export default __webpack_public_path__ + "static/media/banner2.4b5fbae7.png";